import React from 'react';
import { Settings, Phone, Calendar, Brain, type LucideIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ActionCard from './ActionCard';

interface AgentActionPanelProps {
  onTestCall: () => void;
  onHowIWork: () => void;
  campaignPath?: string;
  settingsPath?: string;
  howIWorkDescription?: string;
  viewCampaignDescription?: string;
  testMeDescription?: string;
  testMeIcon?: LucideIcon;
  customizeMeDescription?: string;
}

const AgentActionPanel: React.FC<AgentActionPanelProps> = ({
  onTestCall,
  onHowIWork,
  campaignPath = '/campaigns/call',
  settingsPath = 'call-agent',
  howIWorkDescription = 'See my calling strategy, behavior rules & decision logic.',
  viewCampaignDescription = 'See the steps I follow and your leads assigned to me.',
  testMeDescription = 'Enter your phone number — I\'ll call you in a few seconds.',
  testMeIcon = Phone,
  customizeMeDescription = 'Adjust my persona, scripts, and behavior rules.'
}) => {
  const navigate = useNavigate();

  const handleCustomizeSettings = () => {
    navigate(`/settings#${settingsPath}`);
  };

  const handleViewCampaign = () => {
    navigate(campaignPath);
  };

  return (
    <div className="pt-14 pb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <ActionCard
          icon={Brain}
          title="How I Work"
          description={howIWorkDescription}
          onClick={onHowIWork}
        />
        <ActionCard
          icon={Calendar}
          title="View My Campaign"
          description={viewCampaignDescription}
          onClick={handleViewCampaign}
        />
        <ActionCard
          icon={testMeIcon}
          title="Test Me"
          description={testMeDescription}
          onClick={onTestCall}
        />
        <ActionCard
          icon={Settings}
          title="Customize Me"
          description={customizeMeDescription}
          onClick={handleCustomizeSettings}
        />
      </div>
    </div>
  );
};

export default AgentActionPanel;
